import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

/**
 * MobileGuard - Blocks mobile phone users from accessing protected app routes
 * Allows tablets and desktop users to proceed
 * Redirects mobile users to /mobile-not-supported page
 */
function MobileGuard({ children }) {
  const navigate = useNavigate();
  const [isMobilePhone, setIsMobilePhone] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkIfMobilePhone = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      
      // Detect tablets separately (iPad, Android tablets)
      const isTablet = /(iPad|tablet|playbook|silk)|(android(?!.*mobile))/i.test(userAgent);
      
      // Detect mobile phones only (exclude tablets)
      const isMobilePhone = /iPhone|iPod|Android.*Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
      
      // Also check screen size (phones typically < 768px, tablets >= 768px)
      const isSmallScreen = window.innerWidth < 768;
      
      // Block only if it's a mobile phone AND small screen (not tablets)
      return isMobilePhone && isSmallScreen && !isTablet;
    };

    const isMobile = checkIfMobilePhone();
    setIsMobilePhone(isMobile);
    setIsChecking(false);

    if (isMobile) {
      navigate('/mobile-not-supported', { replace: true });
    }
  }, [navigate]);

  // Show nothing while checking (prevents flash of protected content)
  if (isChecking) {
    return null;
  }

  // If mobile phone, don't render children (will redirect)
  if (isMobilePhone) {
    return null;
  }

  // Desktop or tablet - render protected content
  return children;
}

export default MobileGuard;
